import React, {useEffect} from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTBuyStripe from "../page/VTBuyStripe";
import VTBuy from "../page/VTBuy";
import {TierGridSkeleton} from "../page/VTSkeletons";
import {getVenueSession} from "../../requests/AppSession";

/**
 * User can see VT packages to purchase
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingBuyVT() {

    const [stripePayments, setStripePayments] = React.useState(null);

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession?.venueStripePaymentsFeatureFlag) {
                setStripePayments(true);
            } else {
                setStripePayments(false);
            }
        })
        return function cleanup() {

        };
    }, []);


    return (
        <>
            <Header headerType="UserOnly"/>
            {stripePayments == null && <TierGridSkeleton/>}
            {stripePayments != null && stripePayments ? <VTBuyStripe/> : <VTBuy/>}
            <Footer/>
        </>
    );
}